import "../../assets/css/SalesTrend/FilterBar.css";
import React, { useState, useEffect, use } from "react";
import FilterListIcon from "../../assets/images/FilterImg.svg";
import {
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  ListItemText,
  Button,
  Box,
  Grid,
  CircularProgress,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useSalesContext } from '../../Pages/SalesContext';
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { API_BASE_URL ,API_BASE_URL2} from "../../config/config";
import { useTheme, useMediaQuery } from "@mui/material";

const StyledButton = styled(Button)({
  margin: "8px 4px 2px 4px",
  padding: "0 1px",
  height: "16px",
  lineHeight: "16px",
  width: "calc(50% - 6px)",
  textAlign: "center",
  fontSize: "14px",
  color: "rgba(0, 0, 0, 0.8)",
  border: "1px solid transparent",
  borderRadius: "1px",
  backgroundColor: "rgba(0, 0, 0, 0.18)",
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    boxShadow: "none",
  },
});


// const getAllFilterOptions = (data, selectedUserRole) => {
//   const divisions = new Set();
//   const zones = new Set();
//   const userIds = new Set(); // For MR usernames
//   const flmManagerNames = new Set(); // For FLM manager names
//   const Category = new Set();
//   const userRole = data.user_Details.user_Role.toUpperCase();

//   // Collect filter options from data
//   data.filter_Data.forEach((division) => {
//     if (division.divisionName) {
//       divisions.add(division.divisionName);
//     }
//     division.zones.forEach((zone) => {
//       if (zone.zoneName) {
//         zones.add(zone.zoneName);
//       }
//       zone.employees.forEach((employee) => {
//         if (employee.userRole.toUpperCase() === "MR" && employee.userName) {
//           userIds.add(employee.userName);
//         }
//         if (
//           employee.managerRole?.toUpperCase() === "FLM" &&
//           employee.managerName
//         ) {
//           flmManagerNames.add(employee.managerName);
//         }
//         if (employee.category) {
//     employee.category.forEach((cat) => Category.add(cat));
//   }
//       });
//     });
//   });

//   // Define role hierarchy
//   const hierarchyLevels = {
//      TLM: ["TLM", "SLM", "FLM", "MR"], 
//     SLM: ["SLM", "FLM", "MR"],
//     FLM: ["FLM", "MR"],
//     MR: ["MR"],
//   };
//   const availableRoles = hierarchyLevels[userRole] || ["MR"];

//   // Determine user_id options based on selected role
//   let userIdOptions;
//   if (userRole === "SLM") {
//     if (selectedUserRole === "SLM") {
//       userIdOptions = data.user_Details.userName ? [data.user_Details.userName] : [];
//     } else if (selectedUserRole === "FLM") {
//       userIdOptions = flmManagerNames.size > 0 ? Array.from(flmManagerNames) : ["No FLM Managers Found"];
//     } else if (selectedUserRole === "MR") {
//       userIdOptions = userIds.size > 0 ? Array.from(userIds) : ["No MR Employees Found"];
//       console.log(userIds,userIdOptions, "userIds in SLM");
//     }
//   } else if (userRole === "FLM" && selectedUserRole === "FLM") {
//     userIdOptions = data.user_Details.userName ? [data.user_Details.userName] : [];
//      console.log(userIds,userIdOptions, "userIds in SLM");
//   } else {
//     userIdOptions = userIds.size > 0 ? Array.from(userIds) : ["No Employees Found"];
//   }
// let availableYears = data.years;
// let statusOptions = [];
// statusOptions = data.activeStatus.map((s) => {
//   if (s === "true") return "Active";
//   if (s === "false") return "Inactive";
//   if (s === "null") return "Null";   
//   return s; 
// });

//   return {
//     years: availableYears,
//     division: Array.from(divisions),
//     zone: Array.from(zones),
//     user_role: availableRoles,
//     user_id: userIdOptions,
//     Category: Array.from(Category),
//     status: statusOptions,
//   };
// };
const getFYLabel = (year) => {
  const fy = String(year).match(/\d{4}/)?.[0];
  return fy ? `FY${fy.slice(-2)}` : year;
};

const getAllFilterOptions = (data, selectedUserRole) => {
  const divisions = new Set();
  const zones = new Set();
  const userIds = new Set(); // MR
  const flmManagerNames = new Set(); // FLM
  const slmManagerNames = new Set(); // SLM
  const Category = new Set();

  const userRole = data.user_Details.user_Role?.toUpperCase() || "MR";

  // 🔹 Collect filter options
  data.filter_Data.forEach((division) => {
    if (division.divisionName) {
      divisions.add(division.divisionName);
    }

    division.zones.forEach((zone) => {
      if (zone.zoneName) {
        zones.add(zone.zoneName);
      }

      zone.employees.forEach((employee) => {
        const role = employee.userRole?.toUpperCase();
        const managerRole = employee.managerRole?.toUpperCase();

        // MR Users
        if (role === "MR" && employee.userName) {
          userIds.add(employee.userName);
        }

        // FLM Managers
        if (managerRole === "FLM" && employee.managerName) {
          flmManagerNames.add(employee.managerName);
        }

        // SLM Managers (for TLM)
        if (managerRole === "SLM" && employee.managerName) {
          slmManagerNames.add(employee.managerName);
        }

        // Category
        if (employee.category) {
          employee.category.forEach((cat) => Category.add(cat));
        }
      });
    });
  });

  // 🔹 Role hierarchy
  const hierarchyLevels = {
    TLM: ["TLM", "SLM", "FLM", "MR"],
    SLM: ["SLM", "FLM", "MR"],
    FLM: ["FLM", "MR"],
    MR: ["MR"],
  };

  const availableRoles = hierarchyLevels[userRole] || ["MR"];

  // 🔹 User ID options logic
  let userIdOptions = [];

  if (userRole === "TLM") {
    switch (selectedUserRole) {
      case "TLM":
        userIdOptions = data.user_Details.userName
          ? [data.user_Details.userName]
          : [];
        break;

      case "SLM":
        userIdOptions =
          slmManagerNames.size > 0
            ? Array.from(slmManagerNames)
            : ["No SLM Managers Found"];
        break;

      case "FLM":
        userIdOptions =
          flmManagerNames.size > 0
            ? Array.from(flmManagerNames)
            : ["No FLM Managers Found"];
        break;

      case "MR":
        userIdOptions =
          userIds.size > 0
            ? Array.from(userIds)
            : ["No MR Employees Found"];
        break;

      default:
        userIdOptions = [];
    }
  } else if (userRole === "SLM") {
    switch (selectedUserRole) {
      case "SLM":
        userIdOptions = data.user_Details.userName
          ? [data.user_Details.userName]
          : [];
        break;

      case "FLM":
        userIdOptions =
          flmManagerNames.size > 0
            ? Array.from(flmManagerNames)
            : ["No FLM Managers Found"];
        break;

      case "MR":
        userIdOptions =
          userIds.size > 0
            ? Array.from(userIds)
            : ["No MR Employees Found"];
        break;

      default:
        userIdOptions = [];
    }
  } else if (userRole === "FLM") {
    if (selectedUserRole === "FLM") {
      userIdOptions = data.user_Details.userName
        ? [data.user_Details.userName]
        : [];
    } else {
      userIdOptions =
        userIds.size > 0
          ? Array.from(userIds)
          : ["No MR Employees Found"];
    }
  } else {
    // MR fallback
    userIdOptions =
      userIds.size > 0
        ? Array.from(userIds)
        : ["No Employees Found"];
  }

  // 🔹 Years
  const availableYears = data.years || [];

  // 🔹 Status Mapping
  const statusOptions = (data.activeStatus || []).map((s) => {
    if (s === "true") return "Active";
    if (s === "false") return "Inactive";
    if (s === "null") return "Null";
    return s;
  });

  // 🔹 Final return
  return {
    years: availableYears,
    division: Array.from(divisions),
    zone: Array.from(zones),
    user_role: availableRoles,
    user_id: userIdOptions,
    Category: Array.from(Category),
    status: statusOptions,
  };
};

const getCodeMappings = (data) => {
  const divisionMap = {};
  const zoneMap = {};
  const userIdMap = {};
  const flmToReportsMap = {};
  const CategoryMap = {};
  const years = {};
debugger;
  data.filter_Data.forEach((division) => {
    divisionMap[division.divisionName] = division.divisionCode;
    division.zones.forEach((zone) => {
      zoneMap[zone.zoneName] = zone.zoneCode;
      zone.employees.forEach((employee) => {
        if (employee.userRole.toUpperCase() === "MR") {
          userIdMap[employee.userName] = employee.userId;
        }
        if (
          employee.managerRole?.toUpperCase() === "FLM" &&
          employee.managerName
        ) {
          userIdMap[employee.managerName] = employee.reportingManagerId;
        }
        if (
          employee.managerRole?.toUpperCase() === "FLM" &&
          employee.reportingManagerId
        ) {
          if (!flmToReportsMap[employee.reportingManagerId]) {
            flmToReportsMap[employee.reportingManagerId] = [];
          }
          if (employee.userRole.toUpperCase() === "MR") {
            flmToReportsMap[employee.reportingManagerId].push(employee.userId);
          }
        }
        if (employee.category) {
          CategoryMap[employee.userId] = employee.category;
        }
      });
    });
  });

  years[data.years] = data.years;
  userIdMap[data.user_Details.userName] = data.user_Details.user_Id;

  return { divisionMap, zoneMap, userIdMap, flmToReportsMap, years, CategoryMap };
};


const getAllOptionsForSLM = (data) => {
  const divisions = new Set();
  const zones = new Set();
  const years = new Set();
  const userRole = data.user_Details.user_Role.toUpperCase();
  const Category = new Set();

  data.filter_Data.forEach((division) => {
    if (division.divisionName) {
      divisions.add(division.divisionName);
    }
    division.zones.forEach((zone) => {
      if (zone.zoneName) {
        zones.add(zone.zoneName);
      }
    });
  });

  years.add(data.years);

  return {
    division: Array.from(divisions),
    zone: Array.from(zones),
    years: data.years,
  };
};

const getRelatedSelections = (data, filter, values, selectedUserRole) => {
  const related = {
    division: new Set(),
    zone: new Set(),
    user_id: new Set(),
    years: new Set(),
    Category: new Set(),
  };

  const userRole = data.user_Details.user_Role.toUpperCase();
  const slmUserName = data.user_Details.userName;

  // Special case for SLM selecting self
  if (
    filter === "user_id" &&
    userRole === "SLM" &&
    values.includes(slmUserName)
  ) {
    const allOptions = getAllOptionsForSLM(data);
    return {
      division: allOptions.division,
      zone: allOptions.zone,
      user_id: values,
      years: allOptions.years,
      Category: data.filter_Data.reduce((acc, division) => {
        division.zones.forEach((zone) => {
          zone.employees.forEach((employee) => {
            if (employee.category) {
              acc.add(employee.category);
            }
          });
        });
        return acc;
      }, new Set()),
      
    };
  }

  const flmUserIds = new Set();
  const mrUserIds = new Set();

  data.filter_Data.forEach((division) => {
    division.zones.forEach((zone) => {
      zone.employees.forEach((employee) => {
        const matchesFilter =
          (filter === "division" && values.includes(division.divisionName)) ||
          (filter === "zone" && values.includes(zone.zoneName)) ||
          (filter === "years" && values.includes(data.years)) ||
          (filter === "Category" && values.includes(employee.category)) ||
          (filter === "user_id" &&
            ((employee.userRole.toUpperCase() === "MR" && values.includes(employee.userName)) ||
              (employee.managerRole?.toUpperCase() === "FLM" && values.includes(employee.managerName))));

        if (matchesFilter) {
          related.division.add(division.divisionName);
          related.zone.add(zone.zoneName);

          if (selectedUserRole === "MR") {
            if (employee.userRole.toUpperCase() === "MR") {
              mrUserIds.add(employee.userName);
            }
          } else if (selectedUserRole === "FLM") {
            if (employee.managerRole?.toUpperCase() === "FLM") {
              flmUserIds.add(employee.managerName);
            }
            if (employee.userRole.toUpperCase() === "MR") {
              mrUserIds.add(employee.userName);
            }
          }
        }
      });
    });
  });

  related.user_id = selectedUserRole === "MR"
    ? [...mrUserIds]
    : [...flmUserIds, ...mrUserIds];

  return {
    division: Array.from(related.division),
    zone: Array.from(related.zone),
    user_id: Array.from(related.user_id),
    years: Array.from(related.years),
    Category: Array.from(related.Category),
  };
};


const CustomerFilters =React.memo( ({ user_id, apiEndpoint }) => {
  const { updateSalesUnit, setKpiData, setLoading } = useSalesContext();
  const { userId } = useParams();
     console.log(user_id,userId   ,"line 298")
  const [filterData, setFilterData] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState(null);
  const [tempFilters, setTempFilters] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [initialUserRole, setInitialUserRole] = useState(null);
  const theme = useTheme();
  
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));  // mobile
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md")); // tablet
  const isMdUp = useMediaQuery(theme.breakpoints.up("md")); // desktop
  
  const maxTextLength = isXs ? 4 : isSm ? 7 : 10;

  const getAvailableUserIdOptions = (
    filterData,
    selectedFilters,
    currentFilter
  ) => {
    if (selectedFilters.user_role === "MR") {
      return filterOptions.user_id;
       console.log("MR hierarchy selected" , filterOptions.user_id);
    } else if (selectedFilters.user_role === "FLM") {
      const activeFilters = { ...selectedFilters };
      if (currentFilter !== "division")
        activeFilters.division = filterOptions.division;
      if (currentFilter !== "zone") activeFilters.zone = filterOptions.zone;

      const relatedSelections = getRelatedSelections(
        filterData,
        "all", // Use a dummy filter to get all related user_ids
        [], 
        selectedFilters.user_role
      );
      return relatedSelections.user_id;
    }
    return filterOptions.user_id; // Default fallback
  };
useEffect(() => {

    const finalUserId = user_id || userId;

    console.log("SAP ID from props:", user_id);
    console.log("User ID from params:", userId);
    console.log("Final User ID:", finalUserId);

    if (!finalUserId) return;

    setLoading(true);

    fetch(
      `${API_BASE_URL}Filters/WHFilters?userId=${finalUserId}&userType=SAP_USER`
    )
      .then((response) => response.json())
      .then((data) => {
        console.log("API Response:", data);

        setLoading(false);
        setFilterData(data);

        setInitialUserRole(
          data.user_Details.user_Role.toUpperCase()
        );

        const filterOptions = getAllFilterOptions(
          data,
          data.user_Details.user_Role
        );

        const initialUserRole =
          data.user_Details.user_Role.toUpperCase();

        const initialFilterOptions =
          getAllFilterOptions(data, initialUserRole);

        const preferredCategory = ["A", "B", "C"];
        const availableCategories =
          filterOptions.Category || [];

        const defaultCategory =
          preferredCategory.find((cat) =>
            availableCategories.includes(cat)
          ) || "C";

        const initialFilters = {
          division: filterOptions.division,
          zone: filterOptions.zone,
          user_role: initialUserRole,
          user_id: initialFilterOptions.user_id,
          Category: [defaultCategory],
          years: [filterOptions.years[2]],
          status: [filterOptions.status[0]],
        };

        setSelectedFilters(initialFilters);
        setTempFilters(initialFilters);
      })
      .catch((error) => {
        console.error("Error fetching filter data:", error);
      })
      .finally(() => {
        setLoading(false);
      });

}, [user_id, userId]);

  const convertToCodeFormat = (
    selectedFilters,
    mappings,
    userRole,
    filterData
  ) => {
    debugger;
    const { divisionMap, zoneMap, flmToReportsMap , years } =
      mappings;
const buildFinancialYearRange = (yearsArr) => {
  if (!yearsArr || yearsArr.length === 0) return [];

  const selectedYear = Number(yearsArr[0]);
  if (isNaN(selectedYear)) return [];

  return [
    String(selectedYear - 1),
    String(selectedYear),
  ];
};


    const userIds = getFilteredUserIds(
      filterData,
      selectedFilters,
      userRole,
      flmToReportsMap
    );
console.log("User IDs:", selectedFilters);
    return {
      divisioncode:
        selectedFilters?.division.map((name) => divisionMap[name]) || [],
      zonecode: selectedFilters?.zone.map((name) => zoneMap[name]) || [],
      //  hq : selectedFilters?.hq.map((name) => hqMap[name]) || [],
     user_Role:
  userRole === "TLM"
    ? "TLM"
    : userRole === "SLM"
    ? "SLM"
    : "MR",

      user_Id: userIds,
      category : selectedFilters?.Category || [],
      years: buildFinancialYearRange(selectedFilters?.years),
   PartyMapActive: selectedFilters.status?.map((v) => {
  if (v === "Active") return "true";
  if (v === "Inactive") return "false";
  if (v === "Null") return "null";   // <-- IMPORTANT
  return v;
}),


    };
  };

  useEffect(() => {
    if (selectedFilters && filterData && initialUserRole) {
      const mappings = getCodeMappings(filterData);
      const codeFormat = convertToCodeFormat(
        selectedFilters,
        mappings,
        initialUserRole,
        filterData
      );

      console.log("Code Format:", codeFormat);

      fetch(`${API_BASE_URL}CustomerVisitTracker/CustomerVisitTracker`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(codeFormat),
      })
        .then((response) => response.json())
        .then((data) => {
          setLoading(false);
          setKpiData(data);
        })
        .catch((error) => {
          console.error("Initial API Error:", error);
        });
    }
  }, [filterData, initialUserRole, apiEndpoint]);
  const singleSelectFilters = ["user_role" ,  "years"];

  const handleChange = (filter, event) => {
    debugger;
    const value = event.target.value;
    const filterOptions = getAllFilterOptions(
      filterData,
      selectedFilters.user_role
    );

    if (singleSelectFilters.includes(filter)) {
      if (filter === "user_role") {
        const newFilterOptions = getAllFilterOptions(filterData, value);
        const resetFilters = {
          division: newFilterOptions.division,
          zone: newFilterOptions.zone,
          user_role: value,
          user_id: newFilterOptions.user_id.filter((id) => !id.includes("No ")),
          Category: selectedFilters.Category,
          years: selectedFilters.years,
          status: selectedFilters.status || [],
        };

        setSelectedFilters(resetFilters);
        setTempFilters(resetFilters);

        const mappings = getCodeMappings(filterData);
        const codeFormat = convertToCodeFormat(
          resetFilters,
          mappings,
          value,
          filterData
        );
console.log(codeFormat);
        fetch(`${API_BASE_URL}CustomerVisitTracker/CustomerVisitTracker`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(codeFormat),
        })
          .then((response) => response.json())
          .then((data) => {
            setLoading(false);
            setKpiData(data);
          })
          .catch((error) => {
            console.error("Hierarchy Change API Error:", error);
          });
      }  else if (filter === "years") {
  const newFilterOptions = getAllFilterOptions(filterData, selectedFilters.user_role);
  const resetFilters = {
    ...selectedFilters, // preserve user_role and others
    years: [value], // assign the selected FY value directly
    user_id: newFilterOptions.user_id.filter((id) => !id.includes("No ")),
  };

  setSelectedFilters(resetFilters);
  setTempFilters(resetFilters);

  const mappings = getCodeMappings(filterData);
  const codeFormat = convertToCodeFormat(
    resetFilters,
    mappings,
    selectedFilters.user_role,
    filterData
  );

  fetch(`${API_BASE_URL}CustomerVisitTracker/CustomerVisitTracker`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(codeFormat),
  })
    .then((response) => response.json())
    .then((data) => {
      setLoading(false);
      setKpiData(data);
    })
    .catch((error) => {
      console.error("Hierarchy Change API Error:", error);
    });

  setOpenDropdown(null); // close the dropdown
}else if (filter === "Category") {
  const updatedFilters = {
    ...selectedFilters,
    Category: value,
  };

  setSelectedFilters(updatedFilters);
  setTempFilters(updatedFilters);
  updateSalesUnit(value); // Assuming you already use this

  const mappings = getCodeMappings(filterData);
  const codeFormat = convertToCodeFormat(
    updatedFilters,
    mappings,
    selectedFilters.user_role,
    filterData
  );

  fetch(`${API_BASE_URL}CustomerVisitTracker/CustomerVisitTracker`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(codeFormat),
  })
    .then((response) => response.json())
    .then((data) => {
      setLoading(false);
      setKpiData(data);
    })
    .catch((error) => {
      console.error("Category Change API Error:", error);
    });

  setOpenDropdown(null);
}
 else {
        setSelectedFilters((prev) => {
          const updated = { ...prev, [filter]: value };
          return updated;
        });
        setTempFilters((prev) => ({
          ...prev,
          [filter]: value,
        }));
      }
      setOpenDropdown(null);
    } else {
      if (value.includes("all")) {
        const isSelectingAll =
          tempFilters[filter].length !== filterOptions[filter].length;
        setTempFilters((prev) => ({
          ...prev,
          [filter]: isSelectingAll ? [...filterOptions[filter]] : [],
        }));
      } else {
        setTempFilters((prev) => {
          const updated = {
            ...prev,
            [filter]: value,
          };
          if (filter === "user_id") {
            const relatedSelections = getRelatedSelections(
              filterData,
              filter,
              value,
              selectedFilters.user_role
            );
            return {
              ...updated,
              years: relatedSelections.years >0 ? relatedSelections.years : prev.years,
              division:
                relatedSelections.division.length > 0
                  ? relatedSelections.division
                  : prev.division,
              zone:
                relatedSelections.zone.length > 0
                  ? relatedSelections.zone
                  : prev.zone,
            };
          } else {
            // For other filters, update related filters
            const relatedSelections = getRelatedSelections(
              filterData,
              filter,
              value,
              selectedFilters.user_role
            );
            return {
              ...updated,
              years:filter === "division" ? value : relatedSelections.years >0 ? relatedSelections.years : prev.years,
              division:
                filter === "division"
                  ? value
                  : relatedSelections.division.length > 0
                  ? relatedSelections.division
                  : prev.division,
              zone:
                filter === "zone"
                  ? value
                  : relatedSelections.zone.length > 0
                  ? relatedSelections.zone
                  : prev.zone,
              user_id:
                relatedSelections.user_id.length > 0
                  ? relatedSelections.user_id
                  : prev.user_id,
            };
          }
        });
      }
    }
  };

  const handleApply = (filter) => {
    debugger
    const newSelected = tempFilters[filter];
    const mappings = getCodeMappings(filterData);
    const filterOptions = getAllFilterOptions(
      filterData,
      selectedFilters.user_role
    );
const multiSelectFilters = ["division", "zone", "user_id"];
const skipReverseFilter = ["Category"];


    setSelectedFilters((prev) => {
      let updatedFilters = { ...prev, [filter]: newSelected };

      if (
        multiSelectFilters.includes(filter) &&
        newSelected.length === filterOptions[filter].length
      ) {
        multiSelectFilters.forEach((multiFilter) => {
          updatedFilters[multiFilter] = [...filterOptions[multiFilter]];
        });
      } else {
        const relatedSelections = getRelatedSelections(
          filterData,
          filter,
          newSelected,
          selectedFilters.user_role
        );
        if (filter === "user_id") {
          updatedFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
        } else if (filter === "division") {
          updatedFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
        } else if (filter === "zone") {
          updatedFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
        } else if (filter === "years") {
          updatedFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
        }else if (filter === "Category") {
          updatedFilters.Category = newSelected;
        }
      }

      const prevSelected = prev[filter];
      const hasChanged =
        JSON.stringify(newSelected.sort()) !==
        JSON.stringify(prevSelected.sort());

      if (hasChanged) {
        const codeFormat = convertToCodeFormat(
          updatedFilters,
          mappings,
          selectedFilters.user_role,
          filterData
        );
        console.log("Code Format for Apply:", codeFormat);
        fetch(`${API_BASE_URL}CustomerVisitTracker/CustomerVisitTracker`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(codeFormat),
        })
          .then((response) => response.json())
          .then((data) => {
            setLoading(false);
            setKpiData(data);
          })
          .catch((error) => {
            console.error("API Error:", error);
          });
      }

      return updatedFilters;
    });

    setTempFilters((prev) => {
      const updatedTempFilters = { ...prev, [filter]: newSelected };
      if (
        multiSelectFilters.includes(filter) &&
        newSelected.length === filterOptions[filter].length
      ) {
        multiSelectFilters.forEach((multiFilter) => {
          updatedTempFilters[multiFilter] = [...filterOptions[multiFilter]];
        });
      } else {
        const relatedSelections = getRelatedSelections(
          filterData,
          filter,
          newSelected,
          selectedFilters.user_role
        );
        if (filter === "user_id") {
          updatedTempFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedTempFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
        } else if (filter === "division") {
          updatedTempFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedTempFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
        } else if (filter === "zone") {
          updatedTempFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedTempFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
        } else if (filter === "region") {
          updatedTempFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedTempFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedTempFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
        } else if (filter === "years") {
          updatedTempFilters.division =
            relatedSelections.division.length > 0
              ? relatedSelections.division
              : filterOptions.division;
          updatedTempFilters.zone =
            relatedSelections.zone.length > 0
              ? relatedSelections.zone
              : filterOptions.zone;
          updatedTempFilters.user_id =
            relatedSelections.user_id.length > 0
              ? relatedSelections.user_id
              : filterOptions.user_id;
        }else if (filter === "Category") {
            updatedTempFilters.Category =newSelected;
        }
      }
      return updatedTempFilters;
    });

    setOpenDropdown(null);
  };

  const handleCancel = (filter) => {
    setTempFilters((prev) => ({ ...prev, [filter]: selectedFilters[filter] }));
    setOpenDropdown(null);
  };

  const handleOpen = (filter) => {
    setTempFilters((prev) => ({ ...prev, [filter]: selectedFilters[filter] }));
    setOpenDropdown(filter);
  };
// const getFilteredUserIds = (
//   filterData,
//   selectedFilters,
//   userRole,
//   flmToReportsMap
// ) => {
//   const userIds = new Set();
//   const selectedUserNames = selectedFilters?.user_id || [];

//   // Convert selected user name(s) to their userId from data
//   filterData?.filter_Data?.forEach((division) => {
//     division.zones?.forEach((zone) => {
//       zone.employees?.forEach((employee) => {
//         const role = employee.userRole?.toUpperCase();
//         const empName = employee.userName?.trim();

//         if (
//           selectedUserNames.includes(empName) &&
//           employee.userId &&
//           selectedFilters.user_role === role
//         ) {
//           userIds.add(employee.userId);
//         }
//       });
//     });
//   });

//   const currentUserId = filterData?.user_Details?.user_Id;
//   const currentUserName = filterData?.user_Details?.userName?.trim();

//   if (
//     userIds.size === 0 &&
//     selectedUserNames.includes(currentUserName) &&
//     currentUserId
//   ) {
//     userIds.add(currentUserId);
//   }

//   return Array.from(userIds);
// };


const getFilteredUserIds = (
  filterData,
  selectedFilters,
  userRole,
  flmToReportsMap
) => {
  const userIds = new Set();
  const selectedUserNames = selectedFilters?.user_id || [];

  filterData?.filter_Data?.forEach((division) => {
    division.zones?.forEach((zone) => {
      zone.employees?.forEach((employee) => {
        const role = employee.userRole?.toUpperCase();
        const managerRole = employee.managerRole?.toUpperCase();

        const empName = employee.userName?.trim();
        const managerName = employee.managerName?.trim();

        // ✅ MR
        if (
          selectedFilters.user_role === "MR" &&
          role === "MR" &&
          selectedUserNames.includes(empName)
        ) {
          userIds.add(employee.userId);
        }

        // ✅ FLM → include FLM + their MRs
        if (
          selectedFilters.user_role === "FLM" &&
          managerRole === "FLM" &&
          selectedUserNames.includes(managerName)
        ) {
          userIds.add(employee.reportingManagerId);

          if (flmToReportsMap[employee.reportingManagerId]) {
            flmToReportsMap[employee.reportingManagerId].forEach((mrId) =>
              userIds.add(mrId)
            );
          }
        }

        // ✅ SLM → include SLM + all FLM + MR under them
        if (
          selectedFilters.user_role === "SLM" &&
          managerRole === "SLM" &&
          selectedUserNames.includes(managerName)
        ) {
          userIds.add(employee.reportingManagerId);
        }

        // ✅ TLM → include everything under TLM
        if (
          selectedFilters.user_role === "TLM" &&
          selectedUserNames.includes(managerName)
        ) {
          userIds.add(employee.reportingManagerId);
          if (employee.userId) {
            userIds.add(employee.userId);
          }
        }
      });
    });
  });

  // fallback (self)
  const currentUserId = filterData?.user_Details?.user_Id;
  const currentUserName = filterData?.user_Details?.userName?.trim();

  if (
    userIds.size === 0 &&
    selectedUserNames.includes(currentUserName) &&
    currentUserId
  ) {
    userIds.add(currentUserId);
  }

  return Array.from(userIds);
};

  const getFlmManagerNames = (filterData) => {
    const flmManagerNames = new Set();
    filterData.filter_Data.forEach((division) => {
      division.zones.forEach((zone) => {
        zone.employees.forEach((employee) => {
              if (
                employee.managerRole?.toUpperCase() === "FLM" &&
                employee.managerName &&
                employee.managerName !== ""
              ) {
                flmManagerNames.add(employee.managerName);
              }
            });
          });
    });
    return Array.from(flmManagerNames).length > 0
      ? Array.from(flmManagerNames)
      : ["No FLM Managers Found"];
  };

  const selectStyles = {
    maxWidth: 170,
    height: 22,
    // minWidth:88,
    borderRadius: "1px",
    borderWidth: "1px",
    gap: "4px",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "16px",
    textTransform: "uppercase",
    padding: "0",

    "& .MuiSelect-select": {
      width: "100%",
      textTransform: "uppercase",
      textOverflow: "clip",
      whiteSpace: "nowrap",
      overflow: "hidden",
      padding: "14px",
      paddingTop: "18px",
    },
    "& .MuiSelect-icon": {
      marginLeft: "20px",
      right: "5px",
    },
  };

  if (!filterData || !selectedFilters || !tempFilters) {
    return (
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  const filterOptions = getAllFilterOptions(
    filterData,
    selectedFilters.user_role
  );

  return (
    <div className="new-filter-bar-sticky">
     <div className="filter-container">
      <img src={FilterListIcon} alt="Filter Icon" className="filter-icon" />
      <Grid container spacing={1} sx={{ flexWrap: "nowrap" }}>
        {Object.keys(filterOptions).map((filter) => (
          <Grid item xs={2} key={filter}>
            <InputLabel
              sx={{
                textTransform: "capitalize",
                fontWeight: 400,
                fontSize: "14px",
                // lineHeight: "12px",
                letterSpacing: "0%",
                padding: "3px 3px",
                color: "red",
              }}
            >
              {filter === "user_role"
                ? "Role"
                : filter === "user_id"
                ? "Relevant Employees"
                : filter}
            </InputLabel>
            <FormControl fullWidth>
            <Select
              multiple={!singleSelectFilters.includes(filter)}
              open={openDropdown === filter}
              onOpen={() => handleOpen(filter)}
              onClose={() => {
                setTempFilters((prev) => ({
                  ...prev,
                  [filter]: selectedFilters[filter],
                }));
                setOpenDropdown(null);
              }}
              value={
                singleSelectFilters.includes(filter)
                  ? selectedFilters[filter]
                  : tempFilters[filter]
              }
              onChange={(event) => handleChange(filter, event)}
              
   renderValue={(selected) => {
       const availableOptions = filterOptions[filter] || [];

// Check if all options are selected for multi-select filters
if (
  !singleSelectFilters.includes(filter) &&
  Array.isArray(selected) &&
  selected.length === availableOptions.length &&
  selected.every((item) => availableOptions.includes(item))
) {
  const text = "ALL selected";
        return text.length > maxTextLength
          ? `${text.substring(0, maxTextLength)}..`
          : text;
}
  if (filter === "user_id") {
    const userName = filterData.user_Details.userName;
    const userIdMain = filterData.user_Details.sap_employee_id;
    console.log(userName, "userName", userIdMain, "userIdMain");

    if (
      initialUserRole === "SLM" &&
      selectedFilters.user_role === "SLM"
    ) {
      const text = `${userName || "No Name"} (${userIdMain || "No ID"})`;
      return text.length > maxTextLength
        ? `${text.substring(0, maxTextLength)}...`
        : text;
    }

    if (
      initialUserRole === "FLM" &&
      selectedFilters.user_role === "FLM"
    ) {
      const text = `(${userIdMain || "No ID"})${userName || "No Name"}`;
      return text.length > maxTextLength
        ? `${text.substring(0, maxTextLength)}...`
        : text;
    }

    const currentUserIds =
      tempFilters.user_id.length > 0
        ? tempFilters.user_id
        : selectedFilters.user_id;

    const text =
      currentUserIds.length > 0
        ? currentUserIds
            .map((id) => {
              const match = filterData.user_Details_List?.find(
                (u) => u.user_Id === id
              );
              return match
                ? `(${match.user_Id})${match.userName}`
                : id;
            })
            .join(", ")
        : "No Employees";

    return text.length > maxTextLength
      ? `${text.substring(0, maxTextLength)}...`
      : text;
  }

 if (filter === "years") {
  const yearValue = Array.isArray(selected)
    ? selected[0]
    : selected;

  return getFYLabel(yearValue);
}

  const text = Array.isArray(selected) ? selected.join(", ") : selected;
  return text.length > maxTextLength
    ? `${text.substring(0, maxTextLength)}...`
    : text;
}}


              sx={selectStyles}
              size="large"
            >
              {!singleSelectFilters.includes(filter) && (
                <MenuItem value="all">
                  <Checkbox
                      checked={
                      filter === "user_id" && selectedFilters.user_role === "FLM"
                        ? getFlmManagerNames(filterData).every((manager) =>
                            tempFilters[filter].includes(manager)
                          ) &&
                          tempFilters[filter].every((selected) =>
                            getFlmManagerNames(filterData).includes(selected)
                          )
                        : tempFilters[filter].length ===
                          (filter === "user_id"
                            ? getAvailableUserIdOptions(
                                filterData,
                                selectedFilters,
                                filter
                              ).length
                            : filterOptions[filter].length)
                    }
                    sx={{
                      transform: "scale(0.8)",
                      padding: "0 !important",
                      "& .MuiSvgIcon-root": { fontSize: "19px" },
                    }}
                  />
                  <ListItemText
                    primary="Select All"
                    primaryTypographyProps={{ fontSize: "12px !important" }}
                    sx={{
                      padding: "0 !important",
                      textTransform: "uppercase",
                    }}
                  />
                </MenuItem>
              )}
              
                     {filterOptions[filter].map((option) => {
  let label = option;

  // For "years", convert "FY 2024" to "FY 2025"
 if (filter === "years") {
  label = getFYLabel(option);
}

  console.log(filterOptions)

  return (
    <MenuItem key={option} value={option}>
      {!singleSelectFilters.includes(filter) && (
        <Checkbox
          checked={tempFilters[filter].includes(option)}
          sx={{
            transform: "scale(0.8)",
            padding: "0 !important",
            "& .MuiSvgIcon-root": { fontSize: "19px" },
          }}
        />
      )}
      <ListItemText
        primary={label}
        primaryTypographyProps={{ fontSize: "12px !important" }}
        sx={{ padding: "0 !important", textTransform: "uppercase" }}
      />
    </MenuItem>
  );
})}

              {!singleSelectFilters.includes(filter) && (
                <Box display="flex" justifyContent="space-between" p={0}>
                  <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleApply(filter)}
                    disabled={tempFilters[filter].length === 0}
                  >
                    Apply
                  </StyledButton>
                  <StyledButton
                    variant="outlined"
                    color="secondary"
                    onClick={() => handleCancel(filter)}
                  >
                    Cancel
                  </StyledButton>
                </Box>
              )}
            </Select>
            </FormControl>
          </Grid>
        ))}
      </Grid>
    </div>  
    </div>
   
  );
});


export default CustomerFilters;